import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
import { ComparisonTable, type ComparisonRow } from './ComparisonTable';
import { OFFER } from '../data/offer';
const rows: ComparisonRow[] = [{
  left: 'Forty tabs, three checklists, and the feeling you’re behind',
  right: 'One volume. This month. Nothing else.'
}, {
  left: 'Finding out what things cost after you’ve signed',
  right: 'Knowing every line before you sign anything'
}, {
  left: 'Starting from zero every time you sit down',
  right: 'Open the volume. Follow the order. Close it.'
}];
export function Close() {
  return <section aria-labelledby="close-heading" className="w-full bg-ink" data-id="element-46" data-mp="1c5qw0czj89tn">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 sm:py-24" data-id="element-47" data-mp="17a1rdv8no2qh">
        <h2 id="close-heading" className="font-serif font-normal text-white text-[30px] sm:text-[44px] leading-tight text-center" data-id="element-48" data-mp="12a719twpfh6h">
          You only get these twelve months once.
        </h2>

        <p className="mx-auto mt-7 max-w-xl text-center text-[17px] sm:text-[18px] leading-[1.6] text-white/75" data-id="element-49" data-mp="3ven2hurvjebn">
          Join the couples who plan the whole thing from six volumes and a
          twenty-minute Sunday — and spend the rest of the year actually enjoying
          being engaged.
        </p>

        <p className="mt-8 text-center text-[13px] font-semibold uppercase tracking-kicker text-sage" data-id="element-50" data-mp="3qh3moqfj2thl">
          Budget · Vendors · Details · RSVPs &amp; seating · The final month ·
          The day itself — all sequenced
        </p>

        <div className="mt-14" data-id="element-51" data-mp="mx92clcro4bi">
          <ComparisonTable headers={['Without the plan', 'With the plan']} rows={rows} tone="dark" caption="Planning without the plan, and with it" data-id="element-52" data-mp="8347s3ylmu0f" />
        </div>

        <div className="mt-14 text-center" data-id="element-53" data-mp="2srsa082n1l9a">
          <p className="font-serif font-medium text-white text-[20px] sm:text-[23px] leading-snug" data-id="element-54" data-mp="2suwi3gj85158">
            The 12-Month Wedding Plan™ — 6 Volumes + 5 Bonuses
          </p>
          <p className="mt-3 flex items-baseline justify-center gap-3" data-id="element-55" data-mp="1484i9xmo1dwz">
            <span className="text-clay line-through text-[19px]" data-id="element-56" data-mp="zb5r9nyatn30">
              ${OFFER.anchorPrice}
            </span>
            <span className="font-serif font-normal text-white text-[52px] leading-none" data-id="element-57" data-mp="uh9xyyszcoe6">
              ${OFFER.price}
            </span>
          </p>

          <div className="mt-8 flex flex-col items-center" data-id="element-58" data-mp="klgcur173mks">
            <CtaButton href={OFFER.checkoutUrl} isCheckout variant="onDark" className="w-full sm:w-auto" data-id="element-59" data-mp="kiu5areb172k">
              Yes, I want the complete plan
            </CtaButton>
            <TrustLine tone="dark" className="mt-4 justify-center" data-id="element-60" data-mp="6lytwsakz3jc" />
          </div>
        </div>
      </div>
    </section>;
}